// DEPENDENCIES
import React, { useEffect, useState } from 'react';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';

const SmallCard = (props) => {

    const cardSize = {
        'sm': '--small',
        'md': '--medium',
        'lg': '--large'
    };

    const textPosition = {
        'center': 'centered',
        'left': 'left',
        'right': 'right'
    }

    return (
        <>
            <CustomBlock className={`small-card${props.size ? cardSize[props.size] : "--medium"}`}>
                <CustomBlock className={`title-block ${props.contentPosition ? textPosition[props.contentPosition] : "centered"}`}>
                    <h2>
                        {props.title}
                    </h2>
                </CustomBlock>

                <CustomBlock className={`description-block ${props.contentPosition ? textPosition[props.contentPosition] : "centered"}`}>
                    <p>
                        {props.description}
                    </p>
                </CustomBlock>
            </CustomBlock>
        </>
    )
}

export default SmallCard;